import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomCard from '../../../../../../../components/CustomCard';
import CustomGenericTittleIconDataChip from '../../../../../../../components/CustomGenericTittleIconDataChip';
import { CompletePersonChip, IconScheduleTable } from '../../../../../../../components/buttons/IconButtons';
import { EMPTY_VALUES, currencyFormat, getDateFormat, DATE_TIME_FORMAT_NAME_MODEL } from '../../../../../../../Apis/functions';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

// Left-side card with the payroll user's general details (name, rate, department, contract dates).
const PayrollUserDetailsCard = ({ userDetail }) => {
    const { t } = useTranslation();

    return (
        <CustomCard classes='h-100' classCard='card-border-8px' classContent='p-0'>
            <div className='d-flex justify-content-between align-items-center m-3'>
                <CustomGenericTittleIconDataChip
                    title='details'
                    Icon={CompletePersonChip}
                    border={false}
                    titleBoxClass='d-flex'
                />
            </div>
            <CustomCard classCard='card-border-8px m-3' classContent='p-3'>
                <div className='row align-items-start mb-3'>
                    <div className='col-2 p-0'>
                        <div className='background-primary-100 p-8px border-radius-8px d-flex justify-content-center align-items-center w-44px h-44px'>
                            <CompletePersonChip />
                        </div>
                    </div>
                    <div className='col-10'>
                        <p className='fs-16px ibl-font-w-700 font-color-general-950 mb-0'>
                            {userDetail?.fullName ?? EMPTY_VALUES.DEFAULT}
                        </p>
                        <p className='fs-14px font-color-general-500 mb-0'>
                            {userDetail?.employeeId ?? EMPTY_VALUES.DEFAULT}
                        </p>

                        <div className='border-bottom-shades-300 my-2' />

                        <div className='row'>
                            <div className='col-12 px-0 mb-2'>
                                <p className='fs-14px ibl-font-w-600 font-color-general-700 mb-0'>{t('hourly_rate')}</p>
                                <p className='fs-14px font-color-general-950 mb-0'>
                                    {userDetail?.hourlyRate != null
                                        ? `$${currencyFormat(userDetail.hourlyRate)}`
                                        : EMPTY_VALUES.DEFAULT}
                                </p>
                            </div>
                            <div className='col-12 px-0 mb-2'>
                                <p className='fs-14px ibl-font-w-600 font-color-general-700 mb-0'>{t('privilege')}</p>
                                <p className='fs-14px font-color-general-950 mb-0'>
                                    {t(userDetail?.roleName) ?? EMPTY_VALUES.DEFAULT}
                                </p>
                            </div>
                            <div className='col-12 px-0 mb-2'>
                                <p className='fs-14px ibl-font-w-600 font-color-general-700 mb-0'>{t('department')}</p>
                                <p className='fs-14px font-color-general-950 mb-0'>
                                    {userDetail?.departmentName ?? EMPTY_VALUES.DEFAULT}
                                </p>
                            </div>
                            <div className='border-bottom-shades-300 my-2' />

                            <div className='col-12 px-0 mb-2'>
                                <p className='fs-14px ibl-font-w-600 font-color-general-700 mb-0'>{t('contract_start')}</p>
                                <div className='d-flex align-items-center'>
                                    <div> <IconScheduleTable /></div>

                                    <p className='fs-14px font-color-general-950 mb-0 ml-1'>
                                        {getDateFormat(userDetail?.startDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth)}
                                    </p>
                                </div>
                            </div>
                            <div className='col-12 px-0 mb-2'>
                                <p className='fs-14px ibl-font-w-600 font-color-general-700 mb-0'>{t('contract_end')}</p>
                                <div className='d-flex align-items-center'>
                                    <div> <IconScheduleTable /></div>
                                    <p className='fs-14px font-color-general-950 mb-0 ml-1'>
                                        {userDetail?.startDate === userDetail?.endDate ? t('undefined') : getDateFormat(userDetail?.endDate, false) ?? EMPTY_VALUES.DEFAULT}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </CustomCard>
        </CustomCard>
    );
};

export default PayrollUserDetailsCard;
